import { useEffect, useState } from 'react';
import { hasSegmentConsent } from '@/lib/utils/cookie-consent';

export default function SegmentGate({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element | null {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    setEnabled(hasSegmentConsent());
  }, []);

  if (!enabled) {
    return null;
  }

  return <>{children}</>;
}
